/**
 * Brouillon de formulaire générique (localStorage).
 * Clé : préfixe + tenant + identifiant de fiche.
 */

export interface FormDraftPayload {
  savedAt: string;
  fields: Record<string, string>;
  meta?: Record<string, string>;
}

function draftKey(prefix: string, tenantId: string, draftId: string): string {
  return `${prefix}:${tenantId}:${draftId}`;
}

export function saveFormDraft(
  prefix: string,
  tenantId: string,
  draftId: string,
  fields: Record<string, string>,
  meta?: Record<string, string>,
): void {
  try {
    const payload: FormDraftPayload = {
      savedAt: new Date().toISOString(),
      fields,
      meta,
    };
    localStorage.setItem(draftKey(prefix, tenantId, draftId), JSON.stringify(payload));
  } catch {
    /* quota / mode privé */
  }
}

export function loadFormDraft(
  prefix: string,
  tenantId: string,
  draftId: string,
): FormDraftPayload | null {
  try {
    const raw = localStorage.getItem(draftKey(prefix, tenantId, draftId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FormDraftPayload;
    if (!parsed?.fields || typeof parsed.fields !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearFormDraft(prefix: string, tenantId: string, draftId: string): void {
  try {
    localStorage.removeItem(draftKey(prefix, tenantId, draftId));
  } catch {
    /* ignore */
  }
}
